<template>
	<div v-if="openModal">
		<modal>
			<template slot="header">
				<md-button class="md-simple md-just-icon md-round modal-default-button" @click="closeSelectionModal">
					<md-icon>clear</md-icon>
				</md-button>
				<md-table-toolbar>
					<div class="filter-section">
						<md-field style="margin: 0px 40px">
							<md-input type="search" v-model="searchQuery" clearable placeholder="Search Departments"></md-input>
						</md-field>
					</div>
					<p v-if="checkSelectionLimit" style="color: red; margin: 0px 40px">Only the first 3 departments will be added to your profile</p>
					<p v-if="checkSelectionMade" style="color: red; margin: 0px 40px">Please select at least 3 departments</p>
				</md-table-toolbar>
			</template>

			<template slot="body">
				<div class="company-table">
					<md-table v-model="queriedData" md-card @md-selected="onSelect">
						<md-table-row slot="md-table-row" slot-scope="{ item }" md-selectable="multiple" style="text-align: left">
							<md-table-cell md-label="Departments">{{ item.department }}</md-table-cell>
						</md-table-row>
					</md-table>
				</div>
			</template>

			<template slot="footer">
				<div class="filter-section">
					<md-button class="md-success" @click="confirmSelection"> Confirm</md-button>
					<md-button class="md-danger" @click="cancelDepartmentSelection"> Cancel</md-button>
				</div>
			</template>
		</modal>
	</div>
</template>

<script>
import { Modal } from '@/components';

import 'firebase/compat/firestore';
export default {
	components: {
		Modal,
	},
	props: {
		companyDepartments: { type: Array },
		openDepartmentModal: { type: Boolean },
	},
	data() {
		return {
			searchQuery: '',
			openModal: this.openDepartmentModal,
			isSelected: false,
			newData: null,
			selected: [],
			checkSelectionMade: false,
		};
	},
	computed: {
		queriedData() {
			let result = this.companyDepartments;

			if (this.searchQuery.length > 0) {
				result = result.filter(departments => {
					const departmentName = departments.department.toLowerCase();
					const keyword = this.searchQuery.toLowerCase();
					return departmentName.includes(keyword);
				});
			}

			return result;
		},
		checkSelectionLimit() {
			return this.selected.length > 3;
		},
	},
	methods: {
		closeSelectionModal() {
			this.openModal = false;
			this.$emit('cancelDepartmentSelection', false);
		},

		onSelect(item) {
			this.selected = item;
			this.checkSelectionMade = false;
		},
		confirmSelection() {
			if (this.selected.length >= 3) {
				this.$emit('departmentSelection', this.selected.slice(0, 3));
				this.$emit('cancelDepartmentSelection', false);
			} else {
				this.checkSelectionMade = true;
			}
		},
		cancelDepartmentSelection() {
			this.selected = null;
			this.openModal = false;
			this.$emit('cancelDepartmentSelection', false);
		},
	},
	created() {},
};
</script>

<style scoped>
.data-footer {
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: baseline;
	margin: 0px 20px;
}
.selectedCompany {
	background-color: #ff5722;
}

.filter-section {
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	width: 100%;
	margin-top: 20px;
}
</style>
